import { LocalStop } from '../shared/local-stop.model';
import { Component, OnInit } from '@angular/core';
import { LocalLoad } from '../shared/local-load.model';
import { Carrier } from '../../user-dashboard/shared/carrier.model';


@Component({
  selector: 'app-find-loads',
  templateUrl: './find-loads.component.html',
  styleUrls: ['./find-loads.component.scss'],

})
export class FindLoadsComponent implements OnInit {

  page                     = 1;
  pageSize                 = 10;
  selectedLoad: LocalLoad  = null;
  selectedStop: LocalStop  = null;
  selectedCarrier: Carrier = null;
  preventNavigationFrom    = false;

  constructor() {
  }

  ngOnInit() {
  }

  selectLoad(load: LocalLoad) {
    this.selectedLoad = load;
  }

  selectStop(stop: LocalStop) {
    this.selectedStop = stop;
  }

  selectCarrier(carrier: Carrier) {
    this.selectedCarrier = carrier;
  }

  preventNavigation(hasSelectedLoads) {
    this.preventNavigationFrom = hasSelectedLoads;
  }
}
